<template>
  <div id="language-selector" :class="{'lang-selector': true, 'expanded': state.showLanguage}">
    <v-card-actions @click.stop="toggleMenu">
      <span class="nav-items-lang-mobile">
        <LanguageIconSVG class="icon"/>
        {{ $translate('language.menu')}}
        <ChevronUpSVG v-if="state.showLanguage" class="custom-icon"/>
        <ChevronDownSVG v-if="!state.showLanguage" class="custom-icon"/>
        <div :class="['curr-lang', currentLanguage]">{{ currentLanguageTitle }} </div>
      </span>
      <div class="nav-items-lang-desktop">
        <LanguageIconSVG :color="'#fff'" class="custom-desktop-icon"/>
        {{ currentLanguageTitle }}
        <ChevronUpSVG v-if="state.showLanguage" :color="'#fff'" class="custom-desktop-icon"/>
        <ChevronDownSVG v-if="!state.showLanguage" :color="'#fff'" class="custom-desktop-icon"/>
      </div>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="state.showLanguage" class="language-menu">
        <div
            v-for="menu in languageMenu"
            :key="menu.action"
            class="language-item"
            :class="{ active: menu.active }"
            @click="() => changeLanguage(menu.action)"
        >
          <div class="language-title">{{ menu.title }}</div>
          <div class="language-subtitle">{{ menu.subtitle }}</div>
        </div>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>

import LanguageIconSVG from './icons/LanguageIconSVG.vue';
import ChevronDownSVG from './icons/ChevronDownSVG.vue';
import SettingIconSVG from './icons/SettingIconSVG.vue';
import ChevronUpSVG from './icons/ChevronUpSVG.vue';

export default {
  components: {ChevronUpSVG, SettingIconSVG, ChevronDownSVG, LanguageIconSVG},
  data() {
    return {
      selectedLanguage: '',
      languageMenu: [
        {
          title: 'English',
          subtitle: 'English',
          action: 'en',
          active: true
        },
        {
          title: 'Español',
          subtitle: 'Spanish',
          action: 'es',
          active: false
        }
      ],
      state: {
        showLanguage: 0
      }
    };
  },
  computed: {
    currentLanguage() {
      return this.$store.getters.language
    },
    currentLanguageTitle() {
      if (this.$store.getters.language === "en")
        return this.languageMenu[0].title
      else if(this.$store.getters.language === "es")
        return this.languageMenu[1].title
      else
        return ""
    },
    
  },
  methods: {
    toggleMenu() {
      this.state.showLanguage = !this.state.showLanguage;
    },
    changeLanguage(action) {
      this.selectedLanguage = action;
      this.state.showLanguage = 0; // close the language switcher
      if (action === 'en') {
        this.$store.commit('setLanguage', 'en');
      } else if (action === 'es') {
        this.$store.commit('setLanguage', 'es');
      }
      this.languageMenu.forEach(menu => {
        menu.active = menu.action === action;
      });
    },
    handleClickOutside(event) {
      setTimeout(() => {
        const dropdown = document.getElementById('language-selector');
        if (dropdown && !dropdown.contains(event.target)) {
          this.state.showLanguage = false
        }
      }, 0);
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);

    this.selectedLanguage = this.currentLanguage || 'en'
    // Set correct active state on load
    this.languageMenu.forEach(menu => {
      menu.active = (menu.action === this.selectedLanguage);
    });
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }
};
</script>

<style scoped lang="scss">
@import './../styles/variables.scss';
.language-menu {
  display: flex;
  flex-direction: column;
  padding-left: unset;
  text-align: unset;
}

.language-item {
  text-align: left;
  padding-left: unset;
}

.language-item.active {
  background-color: #00000012;
  font-weight: bold;
}

.language-title {
  font-size: 14px;
  color: #4D4D4D;
  padding-top: 4px;
}

.language-subtitle {
  font-size: 12px;
  color: #707070;
  padding-top: 2px;
  padding-bottom: 4px;
}

.curr-lang {
  color: #707070;
  font-size: small;
  display: inline;
  margin-left: 62px;
  &.es {
    margin-left: 76px;
  }
}
.custom-icon {
  margin-left: 8px;
  display: inline-block;
  vertical-align: middle;
}
.lang-selector {
  cursor: pointer;
  position: relative;
  span {
    font-weight: 600 !important;
  }
}
.nav-items-lang-desktop {
  padding: 0.5rem;
  font-size: 14px;
  
}
.custom-desktop-icon {
  margin-left: 2px;
  display: inline-block;
  vertical-align: middle;
}
.lang-selector.expanded {
  .nav-items-lang-desktop {
    font-weight: bold;
  }
}

#language-selector{

  // mobile-specific styles
  @include smaller-than-tablet {
    .nav-items-lang-desktop {
      display: none;
    }
    .language-item {
      padding-left: 42px;
    }
  }
  @include wider-than-tablet {

    .lang-selector {
      padding-left: 0.5rem;
    }

    .nav-items-lang-mobile {
      display: none;
    }

    .nav-items-lang-desktop {
      &:hover {
        font-weight: bold;
      }
    }

    .language-menu {
      /* Layout Properties */
      width: 130px;
      height: auto;
      /* UI Properties */
      background: #FFFFFF 0% 0% no-repeat padding-box;
      box-shadow: 0px 3px 6px #00000029;
      border: 0.5px solid #E0E0E0;
      border-radius: 4px;
      opacity: 1;
      padding-top: 4px;
      padding-bottom: 4px;
      position: absolute;
      top: 100%; left: 0;
      font: normal normal normal 14px/20px Roboto;
      letter-spacing: 0.25px;
      text-align: left;

      .language-item {
        &:hover {
          background-color: #00000012; // Light gray when hovering
        }
        &:disabled {
          opacity: 100%
        }
      }

    }
  }
}


</style>